import { EDIT_TITLE } from '../constants/assignator';

export const editAssignatorTitle = (title, typeAssignation) => {
	return {
		type: EDIT_TITLE,
		title,
		typeAssignation,
	};
};
